import { useState, useEffect } from 'react';
import moment from 'moment';

/**
 * Auto-detect round type based on current time
 * @returns {string} Round type: 'morning', 'evening', or 'emergency'
 */
const getAutoDetectedRoundType = () => {
    const currentHour = moment().hour();
    if (currentHour < 15) {
        return 'morning'; // Before 3 PM
    } else if (currentHour < 22) {
        return 'evening'; // 3 PM to 10 PM
    } else {
        return 'emergency'; // After 10 PM
    }
};

/**
 * Custom hook to manage doctor round form modal state
 * Auto-detects round type based on current time when modal opens
 * @returns {Object} Modal state and auto-detected round type
 */
export const useDoctorRoundModal = () => {
    const [isModel, SetModel] = useState({ date: null, open: false });
    const [autoDetectedRoundType, setAutoDetectedRoundType] = useState(null);

    useEffect(() => {
        if (isModel?.open && isModel?.date) {
            const detectedType = getAutoDetectedRoundType();
            setAutoDetectedRoundType(detectedType);
        } else {
            setAutoDetectedRoundType(null);
        }
    }, [isModel?.open, isModel?.date]);

    return {
        isModel,
        SetModel,
        autoDetectedRoundType,
        getAutoDetectedRoundType,
    };
};
